export default __webpack_public_path__ + "static/media/slider-share.bc858de0.png";